import React from 'react';
import './TrustStrip.css';

const items = [
  { value: '40+', label: 'Years of training and clinical practice' },
  { value: 'CHI-USA', label: 'Certified hypnotherapy trainer' },
  { value: '4000+', label: 'Lives transformed' },
  { value: 'By appointment', label: 'Sessions only' },
];

const TrustStrip = () => (
  <section className="trust-strip" aria-label="Practice credentials">
    <div className="container">
      <div className="trust-strip__grid">
        {items.map((item, i) => (
          <div key={i} className="trust-strip__item">
            <span className="trust-strip__value">{item.value}</span>
            <span className="trust-strip__label">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TrustStrip;
